import { api } from "@";

// Function to get contact messages with pagination and search filters
export const getContactMessages = (page = 1, perSize, multiSearch) =>
  api.post(
    `/api/AdminContactUs?Page=${page}&pageSize=${perSize}&PhoneNumber=${multiSearch?.phoneNumber}&MessageTitle=${multiSearch?.messageTitle}`,
  );

// Function to save a contact message reply
export const saveContactMessage = (form) => {
  const payload = {
    reply: form.reply,
    contactUsReplyStatus: form.contactUsReplyStatus ? 1 : 0,
    sendReplyToCustomer: form.sendReplyToCustomer,
  };
  return api.post(`/api/AdminContactUs/reply/${form.id}`, payload);
};
